import React from "react";
import axios from "axios";

import { withStyles, makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import CallIcon from "@material-ui/icons/Call";
import AlternateEmailIcon from "@material-ui/icons/AlternateEmail";
import PermIdentityIcon from "@material-ui/icons/PermIdentity";
import { useLocation, useParams } from 'react-router-dom';
import Constants from "../../Utils/Constants";
import LoadingProgress from "../../Common/LoadingProgress";
import { getToken, getHeaders } from "../../Utils/Common";
import store from "../../Common/storage";
import Header from "../../assets/components/header";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Pagination from '@material-ui/lab/Pagination';
import "./../../index.css";
import toastMaker from "../../Common/toastmaker";



const StyledTableCell = withStyles((theme) => ({
  body: {
    fontSize: 16,
    fontWeight: 600,
    padding: 15,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(even)": {
      backgroundColor: "rgba(251, 220, 119, 0.28)",
    },
  },
}))(TableRow);

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  container: {
    maxHeight: "100%",
  },
});

export default function StickyHeadTable(props) {
  const classes = useStyles();
  const [serverData, setServerData] = React.useState(store.get("history"));
  const [page, setPage] = React.useState(1);
  const [pageCount, setPageCount] = React.useState(0);
  const location = useLocation();
  const [total, setTotal] = React.useState('');
  const [search, setSearch] = React.useState('');
  const [filterType, setFilterType] = React.useState('');
  const [filterStatus, setFilterStatus] = React.useState('');
  let interval = null;

  const handleChange = (event, value) => {
    setPage(value);
  };

  React.useEffect(() => {
    load()
  }, [page, filterType, filterStatus]);

  const load = () => {
    const params = [];
    if (search) params.push(`name=${search}`);
    if (filterType !== '') params.push(`allow_exceed=${filterType}`);
    if (filterStatus !== '') params.push(`status=${filterStatus}`);
    const queryString = params.join('&');
    axios.get(Constants.configurationsPvtApiPath + `?paging=yes&per_page=20&page=${page}&order_by=id&order=desc&${queryString}`, getHeaders())
                      .then(response => {
                        setPageCount(response.data.meta.last_page)
                        setTotal(response.data.meta.total)
                        setServerData(response.data.data)
                      }).catch(error => console.error(error))
  };

  return (
    <div className="panal-viewport middle-container">
          <Header name={"Select Company"} />
            <Paper className={`${classes.root} pb-2`}>
                <div className="d-flex align-items-center flex-wrap" style={{gap: "8px", padding: "8px 5px"}}>
                  <input
                    style={{height: "45px", padding:"5px"}}
                    className="input-box"
                    onChange={e => setSearch(e.target.value)}
                    placeholder="Search by name"
                  />
                  <button
                    type="button"
                    className="c-button c-button_secondary"
                    onClick={e => load()}
                    style={{margin:0}}
                  >Search</button>
                  <select
                    style={{height: "45px", padding: "5px 10px", border: "1px solid #ccc", borderRadius: "4px", fontSize: "14px"}}
                    value={filterType}
                    onChange={e => setFilterType(e.target.value)}
                  >
                    <option value="">All</option>
                    <option value="1">Postpaid</option>
                    <option value="0">Prepaid</option>
                  </select>
                  <select
                    style={{height: "45px", padding: "5px 10px", border: "1px solid #ccc", borderRadius: "4px", fontSize: "14px"}}
                    value={filterStatus}
                    onChange={e => setFilterStatus(e.target.value)}
                  >
                    <option value="">All</option>
                    <option value="1">Active</option>
                    <option value="0">Inactive</option>
                  </select>
                </div>
              
              
              <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead >
                    <TableRow id="table-head_rw">
                      
                        <StyledTableCell className="table-hd">
                          Name
                        </StyledTableCell>
    
                        <StyledTableCell className="table-hd">
                          Alias
                        </StyledTableCell>
    
                        <StyledTableCell className="table-hd">
                          Host
                        </StyledTableCell>
    
                        {/* <StyledTableCell className="table-hd">
                          Api Key
                        </StyledTableCell> */}
    
                        <StyledTableCell className="table-hd">
                          Credits
                        </StyledTableCell>
    
                        <StyledTableCell className="table-hd">
                          Status
                        </StyledTableCell>
    
                        <StyledTableCell className="table-hd">
                          Action
                        </StyledTableCell>
    
                    </TableRow>
                  </TableHead>
                  <TableBody >
                    {
                      serverData?.map((c, i) => 
                          <StyledTableRow key={i} >
                            <StyledTableCell className="">
                              {c?.name}
                            </StyledTableCell>
    
                            <StyledTableCell className="">
                              {c?.alias}
                            </StyledTableCell>
    
                            <StyledTableCell className="">
                              {c?.host}
                            </StyledTableCell>
    
                            <StyledTableCell className="">
                              {c?.last_balance} ({c?.allow_exceed ? 'Postpaid' : 'Prepaid'})
                            </StyledTableCell>

                            <StyledTableCell className="">
                              <span style={{
                                display: "inline-block",
                                padding: "3px 12px",
                                borderRadius: "12px",
                                fontSize: "13px",
                                fontWeight: 600,
                                backgroundColor: c?.status == 1 ? "#d4edda" : "#f8d7da",
                                color: c?.status == 1 ? "#1a7a3c" : "#a71d2a",
                                border: `1px solid ${c?.status == 1 ? "#a3d9b1" : "#f1aeb5"}`,
                              }}>
                                {c?.status == 1 ? "Active" : "Inactive"}
                              </span>
                            </StyledTableCell>
    
                            <StyledTableCell className="">
                              <button className="c-button" onClick={() => Constants.navigate(`${Constants.accountmanagement.replace(':id', c.id)}`)} style={{margin: '0 10px'}}> Manage </button>
                            </StyledTableCell>
                          </StyledTableRow>
                        )
                    }
    
                    
                  </TableBody>
                </Table>
              </TableContainer>
              {pageCount > 0 && <div className={`${classes.root} mt-3 mb-3 d-flex justify-content-end`}>
                                  <Pagination 
                                    count={pageCount} 
                                    page={page} 
                                    onChange={handleChange} 
                                    variant="outlined" 
                                    shape="rounded"
                                    />
                                </div>}
            </Paper>
        </div>
  );
}
